<template>
  <ScrollableContainer :id="id" :cart-modal="isCartModal" :dy-rec-widget="true" class="cts-rec-widget">
    <ProductCard
      v-for="(rec, i) in recs"
      v-bind="rec"
      :key="id + i"
      :render-mode="!!isCartModal ? 'cartModal' : ''"
      emit-link-click="linkClick"
      @link-click="cartStore.closeCartModal()"
    />
  </ScrollableContainer>
</template>

<script setup lang="ts">
import { generateIdNoDate } from '~/util/generateId';
import { useCartStore } from '~/store/cart';

defineProps({
  recs: {
    type: Array<object>,
    required: true,
  },
});

const id = generateIdNoDate('CtsRecWidget');
const isCartModal = inject<boolean>('isCartModal', false);

const cartStore = useCartStore();
</script>

<style lang="scss" scoped>
.cart-modal {
  .scroll-container {
    .product-card-container-cart-modal {
      border: 1px solid $color-neutral-cool-100;
      border-radius: 4px;
      padding: 0.5rem;
      margin: 0 0 #{local-functions.rem-calc(20)} 0;
      background-color: $color-neutral-white;
      :deep(.product-card) {
        display: flex;
        gap: 20px;
        .product-tag {
          display: none;
        }
        .product-title {
          color: $color-neutral-cool-900;
          font-size: 1rem;
        }
        .product-details {
          display: flex;
          flex-direction: column;
          margin-top: 0;
          .price-container {
            order: 2;
            margin-bottom: 0;
          }
          .yotpo.bottomLine {
            order: 3;
          }
        }
        .image {
          max-height: #{local-functions.rem-calc(80)};
          max-width: #{local-functions.rem-calc(80)};
        }
        .price-container {
          .current-price,
          .orig-price,
          .orig-price .strikethrough {
            font-size: 0.875rem;
            line-height: 1.5;
          }
          .orig-price {
            margin-left: 5px;
          }
          .savings-cta {
            display: none;
          }
        }
      }
      :deep(.product-card-actions) {
        margin-top: 0;
        .btn {
          margin-left: 100px;
          width: calc(100% - 100px);
        }
      }
    }
  }
}
</style>
